import {useDispatch, useSelector} from "react-redux";
import {globalDataSelector,} from "../../../../redux/slices/globalDataSlice";
import {useSearchParams} from "react-router-dom";
import useGetSearchParams from "../../../../hooks/useGetSearchParams";
import useSetSearchParams from "../../../../hooks/useSetSearchParams";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDebounce} from "../../../../hooks/useDebounce";
import {page, search,} from "../../Statistics/IOS/IOSClicksStats/IOSClicksStats";
import s from "./teams.module.scss";
import SvgSelector from "../../../../components/SvgSelector/SvgSelector";
import UsersTab from "./Tabs/UsersTab/UsersTab";
import {getTableDefaultParams} from "../../../../api/helpers/scripts";
import {INVALID_PAGE_ERROR, OWNER, snackbar_warning, teamsHighLevelAccess} from "../../../../utils/vars/staticVariables";
import {useTranslation} from "react-i18next";
import {user_role} from "../../../../storage/user";
import Header from "../../../../components/Partials/Header/Header";
import OwnerAddUserPopup from "./Popups/OwnerAddUserPopup/OwnerAddUserPopup";
import TeamsTab from "./Tabs/TeamsTab/TeamsTab";
import {
    fetchAllTeams,
    fetchAllUsers,
    fetchTeamsWithParams,
    setSelectedTeamId,
    teamsSelector
} from "../../../../redux/slices/teamsSlice";
import TeamLeadAddUserPopup from "./Popups/TeamLeadAddUserPopup/TeamLeadAddUserPopup";
import useCustomSnackbar from "../../../../hooks/useCustomSnackbar";
import {subscriptionSelector} from "../../../../redux/slices/subscriptionSlice";


const USERS = 'users'
const TEAMS = 'teams'

const tabList = [
    user_role === OWNER ?
        {
            name: "teams",
            icon: "teams-icon",
            value: TEAMS,
        } : null,
    {
        name: "users",
        icon: "teams-users-icon",
        value: USERS,
    },
].filter((item) => item !== null);

const Teams = () => {
    // const [currentTab, setCurrentTab] = useState(tabList[0].value);

    const [isOwnerAddUserPopupActive, setOwnerAddUserPopupActive] = useState(false);
    const [isTeamLeadAddUserPopupActive, setTeamLeadAddUserPopupActive] = useState(false);
    const [isAddTeamPopupActive, setAddTeamPopupActive] = useState(false);

    const underlineRef = useRef(null);

    const {isCollapsedSidebar} =
        useSelector(globalDataSelector);

    const {usersList, allTeamsList, usersListPending, allTeamsPending} =
        useSelector(teamsSelector);

    const {activeSubscription, can_tm_add_count, fetchSubscriptionsPending} = useSelector(subscriptionSelector)

    const dispatch = useDispatch();

    const showSnackbar = useCustomSnackbar();

    const [searchParams, setSearchParams] = useSearchParams();

    const {search: searchValue, page: pageValue, ordering: orderingValue} = useGetSearchParams();

    const updateSearchParams = useSetSearchParams(setSearchParams);

    const {t, i18n} = useTranslation();


    const currentTab = (() => {
        const contentParam = searchParams.get("content");

        if (tabList.find(item => item.value === contentParam)) {
            return contentParam;
        } else {
            return tabList[0].value;
        }
    })();

    const [inputSearchValue, setInputSearchValue] = useDebounce((value) => {
        if (value) {
            updateSearchParams(search, value);
        } else {
            updateSearchParams(search, value, true);
        }
    }, 600);

    // useEffect(() => {
    //   if (!orderingValue) {
    //     // updateSearchParams(ordering, "wallet__balance");
    //   }
    // }, [orderingValue, updateSearchParams]);

    useEffect(() => {
        const activeBtn = document.querySelector(`.${s.active}`);
        if (activeBtn && underlineRef.current) {
            const {left, width} = activeBtn.getBoundingClientRect();
            const parentLeft = activeBtn.parentElement.getBoundingClientRect().left;
            const scrollLeft = activeBtn.parentElement.scrollLeft; // Додаємо врахування скролу

            underlineRef.current.style.width = `${width}px`;
            underlineRef.current.style.transform = `translateX(${left - parentLeft + scrollLeft}px)`;
        }
    }, [currentTab, i18n.language]);

    useEffect(() => {
        if (!searchValue) {
            setInputSearchValue("");
        } else {
            setInputSearchValue(searchValue);
        }
    }, [searchParams]);


    const fetchUsers = useCallback(() => {
        return dispatch(
            fetchAllUsers(
                getTableDefaultParams({
                }),
            ),
        );
    }, [dispatch, searchParams]);

    const fetchTeams = useCallback(() => {
        return dispatch(
            fetchTeamsWithParams(
                getTableDefaultParams({
                    searchParams,
                    defaultPageSize: 25,
                }),
            ),
        );
    }, [dispatch, searchParams]);

    // useEffect(() => {
    //     dispatch(fetchAllTeams())
    //     fetchUsers()
    //     fetchTeams()
    // }, [dispatch, fetchTeams, fetchUsers])

    useEffect(() => {
        dispatch(fetchAllTeams())
        fetchUsers()
    }, [dispatch])

    const setCurrentTab = (value) => updateSearchParams("content", value)


    const checkIfCanAddUserToTeam = () => {
        let showMessage = false;  // Створюємо змінну для перевірки

        if (can_tm_add_count) {
            if (can_tm_add_count < 1) {
                showSnackbar(
                    t("reached_subscription_users_limit"),
                    snackbar_warning,
                );
                showMessage = true;  // Сповіщення показано
            }
        } else {
            if (10 - usersList.length < 1) {
                showSnackbar(
                    t("cannot_add_new_users_without_subscription"),
                    snackbar_warning,
                );
                showMessage = true;  // Сповіщення показано
            }
        }

        return showMessage;  // Повертаємо, чи було показано сповіщення
    };

    return (
        <div
            className={`${s.balancesWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
        >
            <OwnerAddUserPopup
                active={isOwnerAddUserPopupActive}
                setActive={setOwnerAddUserPopupActive}
                // setCurrentTab={(value) => setCurrentTab(value)}
                fetchUsers={fetchUsers}
                fetchTeams={fetchTeams}
            />

            <TeamLeadAddUserPopup
                active={isTeamLeadAddUserPopupActive}
                setActive={setTeamLeadAddUserPopupActive}
                setCurrentTab={(value) => setCurrentTab(value)}
                fetchUsers={fetchUsers}
                fetchTeams={fetchTeams}
            />

            <Header
                searchValue={inputSearchValue}
                setSearchValue={setInputSearchValue}
                // isSearch
                isButton
                buttonText={currentTab === USERS ? t("add_user") : t("add_team")}
                isCreateButton
                isButtonPending={fetchSubscriptionsPending || usersListPending || allTeamsPending}
                buttonHandler={() => {
                    dispatch(setSelectedTeamId(null))
                    if (currentTab === USERS) {
                        const messageShown = checkIfCanAddUserToTeam();  // Перевірка результату

                        if (messageShown) {
                            return;  // Якщо сповіщення показано, зупиняємо виконання коду
                        }

                        // checkIfCanAddUserToTeam()
                        // if (can_tm_add_count < 1) {
                        //     return showSnackbar(
                        //         t("reached_subscription_users_limit"),
                        //         snackbar_warning,
                        //     );
                        // }

                        if (user_role === OWNER && allTeamsList.length === 0) {
                            return showSnackbar(
                                t("create_team_warning_notif"),
                                snackbar_warning,
                            );
                        }

                        setAddTeamPopupActive(false)
                        if (teamsHighLevelAccess.includes(user_role)) {
                            setOwnerAddUserPopupActive(true)
                        } else {
                            setTeamLeadAddUserPopupActive(true)
                        }
                    } else {
                        setOwnerAddUserPopupActive(false)
                        setTeamLeadAddUserPopupActive(false)
                        setAddTeamPopupActive(true)
                    }
                }}
            />
            <div className={s.pageContent}>
                <div className={s.switchPageContentContainer}>
                    <div className={s.buttonsContainer}>
                        {tabList.map(({name, value, icon}) => (
                            <button
                                key={name}
                                onClick={() => updateSearchParams("content", value)}
                                className={`${s.pageBtn} ${currentTab === value ? s.active : ""}`}
                            >
                                <SvgSelector id={icon}/>
                                {t(name)}
                            </button>
                        ))}

                        <div className={s.underline} ref={underlineRef}></div>
                    </div>
                </div>

                {currentTab === USERS && <UsersTab
                    fetchUsers={fetchUsers}
                />}
                {currentTab === TEAMS && <TeamsTab
                    checkIfCanAddUserToTeam={checkIfCanAddUserToTeam}
                    setCurrentTab={(value) => setCurrentTab(value)}
                    isAddTeamPopupActive={isAddTeamPopupActive}
                    setAddTeamPopupActive={setAddTeamPopupActive}
                    setOwnerAddUserPopupActive={setOwnerAddUserPopupActive}
                    fetchTeams={fetchTeams}
                />}
            </div>
        </div>
    );
};

export default Teams;
